import { set } from 'lodash';
import { PROVIDERS_MAPPING } from 'site-modules/shared/components/profile/auth-providers';
import { getCurrentUser } from 'site-modules/shared/components/profile/firebase-auth';

const DELIMITER = ' ';
const DEFAULT_VALUE = '';

/**
 * Return date that is ISO format.
 * @returns {string}
 */
export const getSyncDate = () => new Date().toISOString();

export const splitUserName = userName => {
  const split = (userName || DEFAULT_VALUE).trim().split(DELIMITER);

  return {
    first: split.shift(),
    last: split.join(DELIMITER),
  };
};

// get anonymous id
export const sameFirebaseSession = (profileToSave, currentProfile, uid) => {
  const profileEmail = profileToSave?.identifiers?.email?.[0];
  const currentEmail = currentProfile?.identifiers?.email?.[0];
  return !currentEmail || profileEmail === currentEmail ? uid : null;
};

export const getSocialProfile = (anonymousProfile, uid) =>
  getCurrentUser().then(user => {
    const profile = { identifiers: {} };
    const providers = user?.providerData ?? [];
    providers.forEach(provider => {
      profile.identifiers[PROVIDERS_MAPPING[provider.providerId]] = [provider.uid];
    });
    const provider = providers[0];
    if (!provider?.email) {
      return Promise.reject({ code: `verify/no-email-${provider?.providerId ?? 'unknown'}` });
    }
    profile.identifiers.email = [provider.email];
    const name = splitUserName(provider.displayName);
    if (name.first) {
      set(profile, 'person.firstName', name.first);
    }
    if (name.last) {
      set(profile, 'pii.lastName', name.last);
    }
    return { profile, aid: sameFirebaseSession(profile, anonymousProfile, uid) };
  });
